import { getFeaturedImageUrl, stripHtml } from "../../services/wpPagesApi";
import { acfText } from "../../utils/landingAcf";
import { SITE } from "../../constants/site";
import { buildAbsoluteUrl } from "../../utils/seo";
import { Helmet } from "react-helmet-async";

export function LandingSeo({ page, acf = {}, heroImageUrl = null }) {
  if (!page) {
    return null;
  }

  const title =
    acfText(acf.hero_title) ||
    stripHtml(page.title?.rendered || SITE.name);
  const description =
    acfText(acf.hero_description) ||
    stripHtml(page.excerpt?.rendered || page.content?.rendered || "").slice(
      0,
      160,
    ) ||
    SITE.name;
  const image =
    heroImageUrl || getFeaturedImageUrl(page) || buildAbsoluteUrl("/logoDark.svg");
  const canonicalUrl = buildAbsoluteUrl("/");

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
